import { createAsyncThunk } from '@reduxjs/toolkit';
import { FAQApi } from '../http';
import { IFAQ } from '../models';

const faqApi = new FAQApi();

export const fetchFAQRecord = createAsyncThunk(
  'faq/record',
  async (body: { id: IFAQ['id'] }, { rejectWithValue }) => {
    try {
      return await faqApi.findOne(body);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
